import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import '../common/MdPage.css';
import '../Pagination.css';
import * as constantClass from '../fileWithConstants';
import { ChevronLeftIcon } from '../common/mdPageIcons';
import { createPagedGridController } from '../../hooks/pagedGridClassAdapter';
import * as actasService from '../../services/actas/actasService';
import {
  buildActaExamenMateriaDisplay,
  classifyActasError,
  formatActaExamenEncabezadoDisplay,
  formatActaExamenNotaDisplay,
  formatActaExamenResultadoDisplay,
  formatActaExamenTipo
} from '../../services/actas/actasDto';
import { displayDate } from '../../services/dates/dateService';

export class VerActaExamen extends Component {
  static displayName = VerActaExamen.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      perPage: 10,
      paginationData: [],
      pageCount: 1,
      forcePage: 0,
      showErrorMessage: false,
      errorMessage: '',
      materia: '',
      id: this.props.match.params.id,
      folio: '',
      libro: '',
      fechaExamen: '',
      tipoActa: ''
    };
    this.grid = createPagedGridController({
      fetchPage: (query) => actasService.listActaExamenDetalle(this.state.id, query),
      defaultPageSize: 10,
      onChange: (gridState) => this.applyGridState(gridState)
    });
  }

  async componentDidMount() {
    const canAccess = await constantClass.canAccess('WWActasExamen');
    if (canAccess) {
      this.populateData();
    }
  }

  applyGridState(gridState) {
    this.setState({
      paginationData: gridState.items,
      pageCount: gridState.pageCount,
      perPage: gridState.pageSize,
      loading: gridState.loading,
      forcePage: gridState.forcePage
    });
  }

  handlePageClick = (e) => {
    this.grid.handlePageClick(e).catch((error) => this.handleActasError(error));
  };

  renderalumnosTable(alumnos) {
    if (!alumnos.length) {
      return (
        <div className="md-page__table-card">
          <p className="md-page__empty-state">Sin alumnos en el acta</p>
        </div>
      );
    }

    return (
      <div className="md-page__table-card">
        <table className="md-page__table" aria-labelledby="ver-acta-examen-title">
          <thead>
            <tr>
              <th scope="col">DNI</th>
              <th scope="col">Nombre y Apellido</th>
              <th scope="col">Nota Examen Oral</th>
              <th scope="col">Nota Examen Escrito</th>
              <th scope="col">Nota Examen Promedio</th>
              <th scope="col">Resultado</th>
            </tr>
          </thead>
          <tbody>
            {alumnos.map((alumno) => (
              <tr key={alumno.detalleActaCod}>
                <td>{alumno.alumnoDni}</td>
                <td>{alumno.alumnoNombre}</td>
                <td>{formatActaExamenNotaDisplay(alumno.detalleActaOral, alumno.detalleActaResultado)}</td>
                <td>{formatActaExamenNotaDisplay(alumno.detalleActaEscrito, alumno.detalleActaResultado)}</td>
                <td>{formatActaExamenNotaDisplay(alumno.detalleActaNota, alumno.detalleActaResultado)}</td>
                <td>{formatActaExamenResultadoDisplay(alumno.detalleActaResultado)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  renderMetadataField(label, value, title) {
    const display = String(value ?? '').trim();
    return (
      <div className="md-page__field md-page__field--inline-readonly">
        <span className="md-page__field-label">{label}</span>
        <div
          className="md-page__field-readonly md-page__field-readonly--single-line"
          title={title || display}
        >
          {display}
        </div>
      </div>
    );
  }

  render() {
    const listLoading = this.state.loading && this.state.paginationData.length === 0;
    const contents = listLoading
      ? <p className="md-page__loading"><em>Cargando datos...</em></p>
      : this.renderalumnosTable(this.state.paginationData);

    return (
      <div className="md-page md-ver-acta-examen">
        <Link className="md-page__back-link" to="/md-aex">
          <ChevronLeftIcon />
          Volver al listado
        </Link>

        <div className="md-page__header">
          <h1 id="ver-acta-examen-title" className="md-page__title">Ver Acta de Examen</h1>
        </div>
        <p className="md-page__subtitle">
          Consulte las notas y resultados cargados para cada alumno del acta.
        </p>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
        </div>

        <div className="md-page__form-card">
          {this.renderMetadataField('Materia', this.state.materia)}
          {this.renderMetadataField('Tipo de acta', formatActaExamenTipo(this.state.tipoActa))}
          {this.renderMetadataField('Fecha de examen', displayDate(this.state.fechaExamen))}
          {this.renderMetadataField('Libro', formatActaExamenEncabezadoDisplay(this.state.libro))}
          {this.renderMetadataField('Folio', formatActaExamenEncabezadoDisplay(this.state.folio))}
        </div>

        {contents}

        {!this.state.loading && this.state.pageCount > 1 ? (
          <div className="md-page__pagination">
            <ReactPaginate
              previousLabel="Anterior"
              nextLabel="Siguiente"
              breakLabel="..."
              pageCount={this.state.pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={this.handlePageClick}
              forcePage={this.state.forcePage}
              containerClassName="pagination"
              activeClassName="active"
            />
          </div>
        ) : null}
      </div>
    );
  }

  handleActasError(error) {
    const outcome = classifyActasError(error);
    if (outcome.type === 'timeout') {
      constantClass.RedirectToLogin();
      return;
    }
    this.setState({
      showErrorMessage: true,
      errorMessage: outcome.message,
      loading: false
    });
  }

  async populateData() {
    try {
      actasService.clearActaExamenDetalleCache(this.state.id);
      const returnModel = await actasService.getActaExamenDetalle(this.state.id);
      actasService.seedActaExamenDetalleCache(this.state.id, returnModel);
      const first = returnModel[0];
      this.setState({
        folio: first?.actaExamenFolio ?? '',
        libro: first?.actaExamenLibro ?? '',
        materia: buildActaExamenMateriaDisplay(first),
        fechaExamen: first?.mesaExamenFechaExamen ?? '',
        tipoActa: first?.actaExamenTipo ?? ''
      });
      await this.grid.load();
    } catch (error) {
      this.handleActasError(error);
    }
  }
}
